"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Plugin2 = _interopRequireDefault(require("./Plugin"));

var PIXI = _interopRequireWildcard(require("pixi.js-legacy"));

var _getProperty = require("../../../util/getProperty");

var _limiter = require("../../../util/limiter");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ID = 0;
var VERTICAL_ZOOM = 1;

var YZOOM = function YZOOM(x, y) {
  return 1;
}; // const YZOOM = (x, y) => {
//     let zoom = 1
//     if (y < 500) {
//         zoom = 1 + ((500 - y) / 500) * 1.25
//     }
//     // console.log("VerticalPanning yzoom", Math.round(zoom * 100) / 100, y)
//     return zoom
// }
// const DEFAULT_PANNING_FILE = "panning.json"


var DEFAULT_PANNING_FILE = "vertical-panning.json";

var VerticalPanning = /*#__PURE__*/function (_Plugin) {
  _inherits(VerticalPanning, _Plugin);

  var _super = _createSuper(VerticalPanning);

  function VerticalPanning() {
    var _this;

    _classCallCheck(this, VerticalPanning);

    _this = _super.call(this);
    _this.id = ID++;
    _this._name = "VerticalPanning";
    _this._panning = null;
    _this._panningWasLoaded = false;
    _this._moment = null;
    _this._lastX = null;
    _this._lastY = null;
    _this._enabled = false;
    return _this;
  }

  _createClass(VerticalPanning, [{
    key: "requiresCanvas",
    value: function requiresCanvas() {
      return false;
    }
  }, {
    key: "moment",
    get: function get() {
      return this._moment;
    },
    set: function set(val) {
      var cid = (0, _getProperty.getProperty)("game_clip_id", this._moment, null);
      var vid = (0, _getProperty.getProperty)("game_clip_id", val, null);

      if (cid !== vid) {
        this._panningWasLoaded = false;
        console.log("VerticalPanning: set moment", val);
        this._moment = val;
        this.loadPanningData();
      }
    }
  }, {
    key: "panning",
    get: function get() {
      var main = null;

      if (this._panning) {
        var _iterator = _createForOfIteratorHelper(this._panning),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var p = _step.value;

            if (p.name === "main") {
              main = p;
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return main;
    }
  }, {
    key: "on",
    value: function on(event) {
      if (this._panning) {
        if (event.type === "touchend" || event.type === "mouseup") {
          var now = Date.now();
          var lastOn = this._lastOn ? this._lastOn : 0;
          var diff = now - lastOn;

          if (diff < 100) {
            console.log("VerticalPanning: debounce on", diff, event);
            return;
          }

          this._lastOn = now;
          console.log("VerticalPanning: on", diff, event);
          document.dispatchEvent(new CustomEvent("trc-vertical-panning-tap", {}));
        }
      }

      return true;
    }
  }, {
    key: "loadPanningData",
    value: function loadPanningData() {
      var _this$moment,
          _this2 = this;

      var defaultPanningFile = DEFAULT_PANNING_FILE;

      if (window._trcPanningFile) {
        defaultPanningFile = window._trcPanningFile;
      }

      var basePath = this.moment ? this.moment.base_path : "";
      var dHls = (0, _getProperty.getProperty)("dynamic_hls", this._moment, null);
      var parts = dHls.split("/");
      parts[parts.length - 1] = defaultPanningFile;
      var pFile = parts.join("/");
      var url = "".concat(basePath).concat(pFile);

      if (process.env.REACT_APP_VIDEO_PLAYER_API && !((_this$moment = this.moment) !== null && _this$moment !== void 0 && _this$moment.base_path.includes("http"))) {
        url = "".concat(process.env.REACT_APP_VIDEO_PLAYER_API).concat(url);
      }

      console.log("VerticalPanning: loadPanningData", url);
      (0, _limiter.limiter)({
        url: url,
        game_clip_id: this._moment.game_clip_id
      }, /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(onSuccess, onFailure) {
          var resp, json;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _this2._panningWasLoaded = true;
                  _context.prev = 1;
                  _context.next = 4;
                  return fetch(url);

                case 4:
                  resp = _context.sent;
                  _context.next = 7;
                  return resp.json();

                case 7:
                  json = _context.sent;
                  _this2._panning = json;
                  console.log("VerticalPanning loaded panning data", _this2._panning);
                  document.dispatchEvent(new CustomEvent("trc-vertical-panning-loaded", {
                    detail: !!json
                  }));
                  onSuccess();
                  _context.next = 20;
                  break;

                case 14:
                  _context.prev = 14;
                  _context.t0 = _context["catch"](1);
                  _this2._panning = null;
                  document.dispatchEvent(new CustomEvent("trc-vertical-panning-loaded", {
                    detail: false
                  }));
                  console.error(_context.t0);
                  onFailure();

                case 20:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[1, 14]]);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "reset",
    value: function reset() {
      this._panning = null;
      this._moment = null;

      _get(_getPrototypeOf(VerticalPanning.prototype), "reset", this).call(this);
    }
  }, {
    key: "setup",
    value: function setup(frame, videoInfo, pixi) {
      _get(_getPrototypeOf(VerticalPanning.prototype), "setup", this).call(this, frame, videoInfo, pixi);
    }
  }, {
    key: "update",
    value: function update(frame, videoInfo, pixi) {
      var _this3 = this;

      this.videoId = (0, _getProperty.getProperty)("video_id", videoInfo);
      this.moment = (0, _getProperty.getProperty)("moment", videoInfo);
      this.video = document.querySelector("#".concat(this.videoId, " video.main-video[data-active=\"true\"]"));
      var videoContainer = document.querySelector("#".concat(this.videoId.replace("player", "container"))); // transition nicely from enabled to disabled states

      var nextEnabled = videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer.classList.contains("vertical");

      if (nextEnabled !== this._enabled && !this._enableListening) {
        if (nextEnabled) {
          console.log("VerticalPanning.update enable");
          this._enabled = true;
        } else {
          console.log("VerticalPanning.update setting disable timeout");
          this._enableListening = true;
          setTimeout(function () {
            console.log("VerticalPanning.update disabled");
            _this3._enableListening = false;
            _this3._enabled = videoContainer === null || videoContainer === void 0 ? void 0 : videoContainer.classList.contains("vertical");
          }, 200);
        }
      }

      if (!this.videoId || !this.video || !this.moment || !this.panning) {
        if (this.video) {
          this.video.style.width = "100%";
          this.video.style.height = "100%";
          this.video.style.top = "0px";
          this.video.style.left = "0px";
        }

        return;
      }

      if (!this._enabled) {
        this.video.style.width = "100%";
        this.video.style.height = "100%";
        this.video.style.top = "0px";
        this.video.style.left = "0px";
        return;
      }

      var gameTime = this.moment.dynamic_start + this.video.currentTime - this.moment.dynamic_offset;
      var pan = this.getInterpolateFrame(gameTime, this.panning.frames);
      var containerRect = this.containerElement.getBoundingClientRect(); // fit to height pan left and right
      //let h = Math.round(containerRect.height * VERTICAL_ZOOM)

      var h = Math.round(containerRect.height * YZOOM(pan.cx, pan.cy));
      var w = Math.round(h * (this.video.videoWidth / this.video.videoHeight));
      var x = (containerRect.width - w) / 2;
      var y = (containerRect.height - h) / 2;
      var maxX = x + Math.floor((w - containerRect.width) / 2);
      var minX = x - Math.ceil((w - containerRect.width) / 2);
      var maxY = y + Math.floor((h - containerRect.height) / 2);
      var minY = y - Math.ceil((h - containerRect.height) / 2);

      if (this._lastX == null || this._lastX !== this._lastX) {
        this._lastX = x;
      }

      if (this._lastY == null || this._lastY !== this._lastY) {
        this._lastY = y;
      }

      var px = (pan.cx - 500) / 1000 * w * -1;
      var py = (pan.cy - 500) / 1000 * h * -1;
      x += px;
      y += py; // cap x and y

      if (x > maxX) {
        x = maxX;
      }

      if (x < minX) {
        x = minX;
      }

      if (y > maxY) {
        y = maxY;
      }

      if (y < minY) {
        y = minY;
      } // x = Math.round(x)
      // y = Math.round(y)


      if (this.video.style.width !== "".concat(w, "px")) {
        this.video.style.width = "".concat(w, "px");
      }

      if (this.video.style.height !== "".concat(h, "px")) {
        this.video.style.height = "".concat(h, "px");
      }

      if (this.video.style.left !== "".concat(x, "px")) {
        this.video.style.left = "".concat(x, "px");
      }

      if (this.video.style.top !== "".concat(y, "px")) {
        this.video.style.top = "".concat(y, "px");
      }

      this._lastX = x;
      this._lastY = y; // log stuff only about once a second
      // let ll = this._lastLog ? this._lastLog : 0
      // if (Date.now() - ll > 1000) {
      //     this._lastLog = Date.now()
      // }
    }
  }, {
    key: "getInterpolateFrame",
    value: function getInterpolateFrame(ct, frms) {
      var frmA = {
        t: -1,
        cx: 500,
        cy: 500,
        s: 2
      };
      var frmB = {
        t: -1,
        cx: 500,
        cy: 500,
        s: 2
      }; // find a and b frames

      var _iterator2 = _createForOfIteratorHelper(frms),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _frm = _step2.value;

          if (_frm.t < ct) {
            frmA = _frm;
          } else {
            frmB = _frm;
            break;
          }
        } // console.log("----")
        // console.log("VerticalPanning: getInterpolateFrame A", frmA)
        // console.log("VerticalPanning: getInterpolateFrame B", frmB)

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (frmA.t >= 0 && frmB.t < 0) {
        frmB = frmA;
      }

      var total = frmB.t - frmA.t;
      var per;

      if (total !== 0) {
        per = (ct - frmA.t) / total;
      } else {
        per = 1;
      }

      var frm = {
        t: ct,
        cx: this.interpolate(frmA.cx, frmB.cx, per),
        cy: this.interpolate(frmA.cy, frmB.cy, per),
        s: this.interpolate(frmA.s, frmB.s, per)
      }; // console.log("VerticalPanning: getInterpolateFrame I", frm)

      return frm;
    }
  }, {
    key: "interpolate",
    value: function interpolate(a, b, p) {
      var diff = b - a;
      var amt = diff * p;
      return a + amt;
    }
  }, {
    key: "getFieldFrame",
    value: function getFieldFrame(csp) {
      var _this$containerFrame = this.containerFrame,
          w = _this$containerFrame.w,
          h = _this$containerFrame.h,
          x = _this$containerFrame.x,
          y = _this$containerFrame.y;
      var video = document.querySelector("#".concat(this.videoId, " video.main-video[data-active=\"true\"]"));

      switch (csp.name) {
        case "pip-tr":
          w = w / 4;
          h = w;
          x = x + video.offsetWidth - w;
          break;

        case "pip-br":
          w = w / 4;
          h = w;
          x = x + video.offsetWidth - w;
          y = y + video.offsetHeight - h;
          break;

        case "pip-lt":
          w = w / 4;
          h = w;
          break;

        case "pip-bl":
          w = w / 4;
          h = w;
          y = y + video.offsetHeight - h;
          break;

        case "half-left":
          w = w / 2;
          break;

        case "half-right":
          w = w / 2;
          x = x + video.offsetWidth - w;
          break;
      }

      return this.makeRect(x, y, w, h);
    }
  }]);

  return VerticalPanning;
}(_Plugin2.default);

exports.default = VerticalPanning;